import './../App.css';
import { useEffect, useState } from 'react';
import greybg from "../img/greybg.jpg";
import imageBG from '../img/NosSolutions.jpg';

import { AcceuilToggleItems, AcceuilToggleItemsActive } from '../components/MainComponents';
import { nosSolut } from '../constants/MyConstants';

const backgroundGrey = {
    backgroundImage: `url(${greybg})`,
    height: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};


function NosSolutions() {
    const [param, setParam] = useState(0);

    const switchView = (val) => {
        if (val === 0) {
            setParam(0)
        } else if (val === 1) {
            setParam(1)
        } else if (val === 2) {
            setParam(2)
        } else {
            setParam(3)
        }
    }

    useEffect(() => {
        document.getElementById("vieww1").classList.add('active'); document.getElementById("vieww2").classList.remove('active'); document.getElementById("vieww3").classList.remove('active'); document.getElementById("vieww4").classList.remove('active'); switchView(0);
        document.getElementById("nav-acceuil1").classList.remove('navSelected'); document.getElementById("nav-quisommenous1").classList.remove('navSelected'); document.getElementById("nav-nosolutions1").classList.add('navSelected'); document.getElementById("nav-carrieres1").classList.remove('navSelected'); document.getElementById("nav-contactez1").classList.remove('navSelected');
        document.getElementById("nav-acceuil").classList.remove('navSelected'); document.getElementById("nav-quisommenous").classList.remove('navSelected'); document.getElementById("nav-nosolutions").classList.add('navSelected'); document.getElementById("nav-carrieres").classList.remove('navSelected'); document.getElementById("nav-contactez").classList.remove('navSelected');
        document.documentElement.scrollTop = 0;
    }, [])

    return (
        <div id='mainNosSolutions'>
            <div className='background-img-medium-nosSolutions' style={{
                backgroundImage: "url(" + imageBG + ")",
                backgroundSize: 'cover',
            }}>
            </div>
         <div class=""  style={backgroundGrey}> 
         <div class="container solutionsMain">
                <div id="about" class="solutionsDiv">
                    <div class="solutionsDiv2">
                        <div className='text-title color-blue text-center bold'>Nos Solutions</div>
                    </div>
                </div>

                <div class="solutionsContainer">

                    <div className='acceuil-toggle'>


                        {
                            nosSolut.map((data, index) => {
                                return (
                                    <div key={index} class="text-center acceuil-toggle-item marginTop20">
                                        <AcceuilToggleItemsActive id={data.id} aria={data.aria} toggleView={() => { data.function(); switchView(index) }} image={data.image} title={data.text} />
                                    </div>)
                            })
                        }

                    </div>

                    

                    <div id='descId' class="solutionsDesc ">
                        <div className='greenSeperatorLinefull3'></div>
                        {
                            nosSolut.map((data, index) => {
                                return (
                                    param === index && <div key={index} class="slide solutionsDesc-child">

                                            <div class="solutionsDesc-child-title color-blue bold">{data.text}</div>
                                            <div class="solutionsDesc-child-p">{data.p2}</div>

                                    </div>
                                )
                            })

                        }
                    </div>
                </div>
            </div>
            </div>  
            <div class="scroll-top-icon scroll-top myscroll-top cursor-pointer" onClick={() => window.scrollTo({top: 0, left: 0, behavior: 'smooth' })}><i class="fa fa-angle-up fa-2x"></i></div>
        </div>


    );
}

export default NosSolutions;

